import { gql } from "@apollo/client";

export const CALCULATE_CART = gql`
  mutation calculateCart($input: CalculateCartInput!, $from: Date!, $until: Date!) {
    calculateCart(input: $input) {
      cart {
        priceBreakdown {
          withDiscount
          withoutDiscount
          discountPercentage
        }
        paymentConfig {
          paymentType
          downPaymentPercentage
        }
        accommodations {
          extras {
            id
            total
            quantity
            calculatedQuantity
            total
          }
          identifier
          rateBasePrice
          priceBreakdown {
            withDiscount
            withoutDiscount
            discountPercentage
          }
          ratePlan {
            id
            name
            defaultPriceBreakdown(from: $from, until: $until) {
              discountPercentage
              withDiscount
              withoutDiscount
            }
            description
          }
        }
        downPaymentAmount
      }
    }
  }
`;
